import { FormEvent, FunctionComponent, useEffect, useState } from "react"
import styled from "styled-components"
import Button from "../../../components/Button";
import FormControl from "../../../components/FormControl";
import Input from "../../../components/Input";
import Tag from "../../../components/Tag";
import Text from "../../../components/Text";
import { useBillingHandlers } from "../../../services/actions/billing/useBillingHandlers";
import { useAppActions } from "../../../stores/application/useAppActions";
import { useBillingStore } from "../../../stores/billing/useBillingStore";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { styles } from '../../../styles/themes/style'
import { formatCurrency, formatPrice } from "../../../utils";


interface IDiscountFormState {
    couponCode: string,
    disabled: boolean
}

interface IDiscountFormBoxProps {
    discountAmount: number,
    currency?: string
    isLoading?: boolean
}

const DiscountFormBox: FunctionComponent<IDiscountFormBoxProps> = ({ discountAmount, currency = 'usd', isLoading }) => {
    const formOriginalState: IDiscountFormState = {
        couponCode: "",
        disabled: true
    }
    //hooks
    const { applyCouponHandler, removeCouponHandler } = useBillingHandlers()
    const { setToast } = useAppActions()
    //const { setConfirmationModal } = useAppHandlers() //todo: add confirmation when removing coupon
    const { store: { appliedCoupon } } = useBillingStore() //todo: return coupon code with the coupon values
    const [discountFormState, setDiscountFormState] = useState<IDiscountFormState>({ ...formOriginalState })
    
    useEffect(() => {
        if (appliedCoupon) resetForm()
    }, [appliedCoupon])

    useEffect(() => {
        const promoCouponCode = localStorage.getItem('promoCouponCode')
        promoCouponCode && applyCouponHandler(JSON.parse(promoCouponCode))
    }, [])

    const resetForm = () => setDiscountFormState({ ...formOriginalState })
    const validateForm = (): string => {
        return discountFormState.couponCode.length > 0 ? "" : "Coupon code empty!"//todo: create Form interface with errors and utility validations
    }
    const submitFormHandler = (event: FormEvent) => {
        event.preventDefault()
        const errorMessage = validateForm()
        if (!errorMessage) {
            applyCouponHandler(discountFormState.couponCode)
        } else {
            setToast({ type: 'error', message: errorMessage })
        }
    }

    return (
        <StyledDiscountContainer>
            <StyledForm onSubmit={submitFormHandler}>
                <FormControl $width="170px" $orientation="row">
                    <Input prefilledValue={discountFormState.couponCode} placeholder="Coupon Code" onChangeHandler={value => setDiscountFormState({ ...discountFormState, couponCode: value, disabled: false })} />
                </FormControl>
                <Button $type="grey" $bigButton type="submit" disabled={discountFormState.disabled}>Apply Coupon</Button>
            </StyledForm>
            {appliedCoupon && <AppliedDiscountLine>
                <AppliedDiscountLabel>
                    <Text $paragraph1 $capitalize>{'Discount'}</Text>
                    <Tag $borderColor={styles.colors.primary600} $color={styles.colors.primary100} title={appliedCoupon?.couponCode} onDestructiveClickHandler={() => removeCouponHandler()} />
                </AppliedDiscountLabel>
                {isLoading ? <LoadingSpinner /> : <Text $paragraph1>-{`${formatCurrency(currency ?? 'usd')}${formatPrice(discountAmount ? discountAmount * 100 : 0)}`}</Text>}
            </AppliedDiscountLine>}
        </StyledDiscountContainer>
    )
}

const StyledDiscountContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 15px;
`
const AppliedDiscountLine = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
const AppliedDiscountLabel = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`
const StyledForm = styled.form`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
export default DiscountFormBox